<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'corporative-information-modal.share-public-link'">Compartir enlace</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info"
      [afTranslate]="'public-link.share-link-info'">_Se notificará la publicación por correo electrónico a las personas que selecciones.</p>
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-contacts
        [field]="shareLinkModal.contactsField"
        (sendContacts)="receiveContacts($event)">
      </field-type-contacts>
      <field-type-rich-text-editable
        [field]="shareLinkModal.commentField"
        [preSelectItem]="shareLinkModal.comment"
        (itemSelected)="shareLinkModal.comment = $event.newValue">
      </field-type-rich-text-editable>
      <field-type-switch [field]="{label: 'public-link.no-copy'| afTranslate}"
        [preSelectItem]="shareLinkModal.checkCopyNotification"
        (itemSelected)="shareLinkModal.checkCopyNotification = $event.newValue">
      </field-type-switch>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer-container">
    <button class="common-button__text-noborder"
      [disabled]="!shareLinkModal.htmlModelNotify"
      (click)="openPreviewNotify()">
      <i class="lf-icon-visible common-icon__md"></i>
      <span class="common-button__text-title"
        [afTranslate]="'corporative-information-modal.notify-model'">_Ver modelo de notificación</span>
    </button>
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="shareLink()">
        <span class="common-button__text-title"
          [afTranslate]="'common.share'">_Compartir</span>
      </button>
    </div>
  </div>
</div>
